import { AfterContentInit, Directive, Input, Renderer2 } from '@angular/core';
import { MatBadge } from '@angular/material/badge';

@Directive({
  selector: '[matBadgeColorize]'
})
export class MatBadgeColorizeDirective implements AfterContentInit {

	@Input() matBadgeColorize: string;

  	constructor(private matBadge: MatBadge,
				private renderer: Renderer2) { }

	ngAfterContentInit(): void {
		if(this.matBadge?.getBadgeElement() && this.matBadgeColorize)
            this.matBadgeColorize.split(' ').each((className: string) =>
                this.renderer.addClass(this.matBadge.getBadgeElement(), className)
            );
	}
}
